import { ErrorBoundary } from "@sentry/react";
import { Route, Routes } from "react-router-dom";
import { CorporateMasterErrorFallback } from "../components/CorporateMasterErrorFallback";
import { CorporateMasterDetail } from "./CorporateMasterDetail";
import { CorporateMasterList } from "./CorporateMasterList";

// 外部データ由来の想定外の値で描画が落ちても白画面にしないよう、法人マスタ配下だけを
// ErrorBoundary で包む（Sentry へ送信し、代替UIで再読み込みを促す）。
export const CorporateMasterRoutes: React.FC = () => (
  <ErrorBoundary
    fallback={({ resetError }) => (
      <CorporateMasterErrorFallback resetError={resetError} />
    )}
  >
    <Routes>
      <Route path=":corporateNumber" element={<CorporateMasterDetail />} />
      <Route path="" element={<CorporateMasterList />} />
    </Routes>
  </ErrorBoundary>
);
